import {WorkingHoursTable} from './WorkingHoursTable/WorkingHoursTable'
import {
	Card,
	CardBody,
	Stack,
	Heading,
	Table,
	TableCaption,
	TableContainer,
	Tbody,
	Th,
	Thead, Td,
	Tr, Button, Box, useBreakpointValue, VStack,
	HStack, Text
} from '@chakra-ui/react'
import { useContext } from 'react'

import {Spinner} from '@chakra-ui/react'
import { useState } from 'react'
import {useParams} from 'react-router-dom'
// import {WorkingHoursTableRow} from './WorkingHoursTable/WorkingHoursTableRow/WorkingHoursTableRow'
import {WorkingHoursExportButton} from './WorkingHoursExportButton/WorkingHoursExportButton'
import { Filters } from 'components/Filters'
import {useWorkingHours} from 'hooks/useWorkingHours/useWorkingHours'

import Pagination from 'components/Pagination/Pagination'
import {DateYMD} from 'components/Date/DateYMD'
import {DateSecondsToTime} from 'components/Date/DateSecondsToTime'
import {DateHMS} from 'components/Date/DateHMS'
import {WorkingHourModal} from './WorkingHourModal/WorkingHourModal'
import {WorkingHourDeleteButton} from './WorkingHourDeleteButton/WorkingHourDeleteButton'
import { CompaniesContext } from 'stores/CompaiesContext'
import { useUsers } from 'hooks/useUsers/useUsers'

export const WorkingHours = () => {
	
	const [filteredHours, setFilteredHours] = useState()
	const { userId } = useParams()
	const { workingHours, updateWorkingHours, handleDeleteWorkingHour, handlePageChange, filters, setFilters, deleteMany } = useWorkingHours(userId)

	const { users } = useUsers()

	const { companies } = useContext(CompaniesContext)

	const isMobile = useBreakpointValue({base: true, lg: false})
	
	return (
	<div>
		<Heading m={3} size='md'> Working Hours </Heading>
		{/* <Card m={2} > */}
			<Stack direction='row' spacing={4} align='center' justify='end'>	
				<WorkingHoursExportButton filters={filters} setFilteredHours={setFilteredHours} />
				{filters?.dateFrom && filters?.dateTo && 
				<Button colorScheme='red' size='sm' onClick={() => {
					deleteMany()
				}}>Delete</Button>}
			</Stack>
			{/* <CardBody > */}
				<Filters
					filters={filters ?? {}}
					setFilters={setFilters}
					companies={companies}
				/>
				{isMobile ? (
				<VStack spacing={4} align='stretch' mt={4}>
					{ workingHours?.data?.map((workingHour) => (
						<Box key={workingHour._id} borderWidth='1px' borderRadius='12px' p={4}>
                            <Text fontWeight='600' fontSize='md' mb={2}>                                 
								{workingHour.user?.name} {workingHour.user?.last_name}<br/>{workingHour.user?.identify}								
							</Text>
							<Text fontSize='sm' mb={2}>
								{workingHour.counting?.store?.company?.name}{workingHour.counting?.store?.name}<br/>
								<DateYMD date={workingHour.time_driving_to_work_opened} />
                            </Text>
							<VStack align='stretch' spacing={1} borderTopWidth='1px' pt={2} fontSize='sm'>								
								<HStack>
									<Text color='gray.500'>Driving Start</Text>
									<Text><DateHMS date={workingHour.time_driving_to_work_opened}/></Text>
								</HStack>
								<HStack>
									<Text color='gray.500'>Working (period)</Text>
									<Text><DateHMS date={workingHour.time_work_opened}/> <br/> <DateHMS date={workingHour.time_work_closed}/></Text>
								</HStack>
								<HStack>
									<Text color='gray.500'>Driving Finish</Text>
									<Text><DateHMS date={workingHour.time_driving_from_work_closed}/></Text>
								</HStack>
								<HStack>
									<Text color='gray.500'>Driving</Text>
									<Text><DateSecondsToTime seconds={workingHour.total_drive_time} /></Text>
								</HStack>
								<HStack>
									<Text color='gray.500'>Work</Text>
									<Text><DateSecondsToTime seconds={workingHour.total_work_time} /></Text>
								</HStack>
								<HStack>
									<Text color='gray.500'>Total</Text>
									<Text><DateSecondsToTime seconds={workingHour.total_time} /></Text>
								</HStack>
							</VStack>
							<HStack mt={3} justify='flex-end' spacing={2}>
								<WorkingHourModal
											mode='new'
											workingHour={workingHour}
											updateWorkingHours={updateWorkingHours}
											users={users}
										/>
								<WorkingHourModal
											id={workingHour._id}
											workingHour={workingHour}
											updateWorkingHours={updateWorkingHours}
										/>
								<WorkingHourDeleteButton id={workingHour._id} handleDeleteWorkingHour={handleDeleteWorkingHour} />
							</HStack>
						</Box>
						))}
				</VStack>
                ) : (
				<TableContainer >
					<Table variant='striped'>
						<TableCaption>List of the Working Hours</TableCaption>
						<Thead>
							<Tr>
								<Th width='30px'>User/TZ</Th>
								{/* <Th size='sm'>TZ</Th> */}
								<Th width='30px'>Date</Th>
								<Th width='30px'>Driving Start</Th>
								<Th width='30px'>Working (period)</Th>
								{/* <Th>Working Finish</Th> */}
								<Th width='30px'>Driving Finish</Th>
								<Th>Driving</Th>
								<Th>Work</Th>
								<Th>Total</Th>
								<Th>Company/Shop</Th>
								{/* <Th>Shop</Th> */}
								<Th>Actions</Th>
							</Tr>
							{/* <WorkingHoursFilters workingHours={workingHours} updateWorkingHours={updateWorkingHours} /> */}
							{/*<Tr>
								<Filters
									filters={filters ?? {}}
									setFilters={setFilters}
									companies={companies}
								/>
							</Tr>*/}
						</Thead>
						<Tbody >
							{ workingHours?.data?.map(workingHour => (
								<Tr key={workingHour._id}>
									<Td width='30px'>{`${workingHour.user?.name} ${workingHour.user?.last_name}`}<br/>{workingHour.user?.identify}</Td>
									{/* <Td></Td> */}
									<Td width='30px'><DateYMD date={workingHour.time_driving_to_work_opened} /></Td>
									<Td width='30px'>
										<DateHMS date={workingHour.time_driving_to_work_opened}/>
									</Td>
									<Td width='30px'>
										<DateHMS date={workingHour.time_work_opened}/> <br/> <DateHMS date={workingHour.time_work_closed}/>
									</Td>
									{/* <Td>
										
									</Td> */}
									<Td width='30px'>
										<DateHMS date={workingHour.time_driving_from_work_closed}/>
									</Td>
									<Td>
										<DateSecondsToTime seconds={workingHour.total_drive_time} />
									</Td>
									<Td>
										<DateSecondsToTime seconds={workingHour.total_work_time} />
									</Td>
									<Td>
										<DateSecondsToTime seconds={workingHour.total_time} />			
									</Td>
									<Td>{workingHour.counting?.store?.company?.name}<br/>{workingHour.counting?.store?.name}</Td>
									{/* <Td></Td> */}
									<Td>
										<WorkingHourModal
											mode='new'
											workingHour={workingHour}
											updateWorkingHours={updateWorkingHours}
											users={users}
										/>
										<WorkingHourModal
											id={workingHour._id}
											workingHour={workingHour}
											updateWorkingHours={updateWorkingHours}
										/>
										<WorkingHourDeleteButton id={workingHour._id} handleDeleteWorkingHour={handleDeleteWorkingHour} />
									</Td>
								</Tr>
								// <WorkingHoursTableRow
								// 	key={workingHour._id}
								// 	id={workingHour._id}
								// 	userId={workingHour.user_id}
								// 	createdAt={workingHour.created_at}
								// 	totalTime={workingHour.total_time}
								// 	totalWorkTime={workingHour.total_work_time}
								// 	totalDriveTime={workingHour.total_drive_time}
								// 	storeName={workingHour.counting?.store?.name}
								// 	companyName={workingHour.counting?.store?.company?.name}
								// 	timeDrivingStart={workingHour.time_driving_to_work_opened}
								// 	timeDrivingToWorkClosed={workingHour.time_driving_to_work_closed}
								// 	timeWorkingStart={workingHour.time_work_opened}
								// 	timeWorkingClosed={workingHour.time_work_closed}
								// 	timeDrivingFromWorkStart={workingHour.time_driving_from_work_opened}
								// 	timeDrivingClosed={workingHour.time_driving_from_work_closed}
								// 	userTz={workingHour.user?.identify}
								// 	name={`${workingHour.user?.name} ${workingHour.user?.last_name}`}
								// 	date={workingHour.created_at}
								// 	updateWorkingHours={updateWorkingHours}
								// 	workingHour={workingHour}
								// 	handleDeleteWorkingHour={handleDeleteWorkingHour}
								// />
							))}
						</Tbody>
					</Table>
					
				</TableContainer>
				)}
				{ !workingHours?.data && <Spinner/> }
				<Pagination lastPage={ workingHours?.last_page ?? 1 } getData={ handlePageChange } />
			{/* </CardBody> */}
		{/* </Card> */}
		</div>
	)
}